import { render, staticRenderFns } from "./notifications-container.vue?vue&type=template&id=1a473d63&scoped=true&lang=pug"
import script from "./notifications-container.js?vue&type=script&lang=js&external"
export * from "./notifications-container.js?vue&type=script&lang=js&external"
import style0 from "./notifications-container.vue?vue&type=style&index=0&id=1a473d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a473d63",
  null
  
)

export default component.exports